module.exports = __webpack_public_path__ + "img/experienceBannerHomeIcon.3f9142da.svg";